import { useNavigate } from "react-router-dom";
import { FlaskConical, Stethoscope, Sprout, UserPlus } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { useDemo } from "@/hooks/useDemo";

const hoursLeft = (iso) => Math.max(1, Math.round((new Date(iso) - Date.now()) / 36e5));

/** Sticky strip for sandbox sessions: what this is, how long it lasts, hop between views, or leave to sign up. */
export function DemoBanner() {
  const { user, logout } = useAuth();
  const { busy, switchTo } = useDemo();
  const navigate = useNavigate();
  if (!user?.is_demo) return null;
  const clin = user.role === "clinician";
  const createAccount = async () => { navigate("/register"); await logout(); };
  return (
    <div className="px-3 sm:px-8 py-2 bg-stone-900 text-stone-100 text-sm flex items-center justify-between gap-3 flex-wrap" data-testid="demo-banner">
      <div className="inline-flex items-center gap-2 min-w-0">
        <FlaskConical className="w-4 h-4 text-amber-300 shrink-0" />
        <span data-testid="demo-banner-text">
          <strong className="text-amber-200">Demo garden</strong> · sample data, nothing is saved to a real account · resets in about {hoursLeft(user.demo_expires_at)} h
        </span>
      </div>
      <div className="flex items-center gap-2 flex-wrap">
        <button onClick={() => switchTo(clin ? "client" : "clinician")} disabled={busy} data-testid="demo-switch-view"
          className="inline-flex items-center gap-1.5 text-xs font-semibold px-3 py-1.5 rounded-full border border-stone-600 text-stone-100 hover:bg-stone-700 transition-colors disabled:opacity-50">
          {clin ? <Sprout className="w-3.5 h-3.5" /> : <Stethoscope className="w-3.5 h-3.5" />}
          {clin ? "Back to the member view" : "Peek at the coach view"}
        </button>
        <button onClick={createAccount} data-testid="demo-create-account" className="inline-flex items-center gap-1.5 text-xs font-semibold px-3 py-1.5 rounded-full bg-amber-400 text-stone-900 hover:bg-amber-300 transition-colors">
          <UserPlus className="w-3.5 h-3.5" /> Create your account
        </button>
      </div>
    </div>
  );
}
